import { Typography, Box } from "@mui/material";

const Header = ({ title, subtitle, sxTitle = {}, sxSubtitle = {} }) => {
  return (
    <Box mb="30px">
      <Typography
        variant="h4" // ⬅️ Cambiar de h2 a h4 para que no sea tan grande
        sx={{
          fontSize: "24px", // ⬅️ Igual que text-2xl en Tailwind
          fontWeight: "bold",
          color: "#202224", // ⬅️ Color igual al Figma
          m: "0 0 5px 0",
          ...sxTitle,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: "14px", // ⬅️ Tamaño más elegante y sutil
          color: "#6b7280", // ⬅️ Gris claro del Figma
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;